import styled from 'styled-components';

export const LogoWrapper = styled.div`
  display: flex;
  height: 40px;
  padding: var(--spacing-none, 0);
  justify-content: center;
  align-items: center;
  gap: 103.65px;
  align-self: stretch;
  cursor: pointer;
`;

export const IconsWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SettingsWrapper = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
